<template>
  <div class="dea-avatar-selection">
    <div class="dea-avatar-selection__image-container">
      <picture class="dea-avatar-selection__image">
        <img :src="src" />
      </picture>
    </div>
    <div class="dea-avatar-selection__cta-container">
      <Links :class-name="`dea-links--large dea-links--pointer ${linkColorClass}`" v-on="$listeners">
        Modifica immagine di profilo
      </Links>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";

export default {
  name: "ChangeAvatar",
  components: { Links },
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
  },
  computed: {
    linkColorClass() {
      if (this.linkColor) return `dea-links--${this.linkColor}`;
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.dea-avatar-selection {
  @include media("<=m") {
    padding: 0 $space-base !important; //sass-lint:disable-line no-important
    width: min-content !important; //sass-lint:disable-line no-important
  }

  &__cta-container {
    .dea-links {
      &__label {
        white-space: nowrap;
      }
    }
  }
}
</style>
